import React from 'react';
import styled from 'styled-components';
import { Checkbox } from '../../../../../components';
import { SupervisorRoleTypes } from '../../../../Nomination';
import { type RenderData } from '../../types';
import { NOMINATION_TEXT } from '../../lang';
import { type SupervisorValue } from '../../../../Nomination/graphql';

const SUPERVISOR_TEXT = NOMINATION_TEXT.SUPERVISOR_TEAM.SUPERVISOR;
type SupervisorFormProps = {
  data: SupervisorValue;
};
export const SupervisorForm: React.FC<SupervisorFormProps> = (
  props: SupervisorFormProps,
) => {
  const { data: supervisorData } = props;
  const {
    type,
    title,
    jobTitle,
    givenName,
    surname,
    department,
    institution,
    email,
    previousSuccessfulSupervision,
    isDrcChair = false,
    isDoRPgS = false,
  } = supervisorData ?? {};

  const polyuStaff =
    type === SupervisorRoleTypes.CHIEF_SUPERVISOR ||
    type === SupervisorRoleTypes.CO_SUPERVISOR;

  const renderData: RenderData[] = [
    {
      label: SUPERVISOR_TEXT.NAME,
      value: `${surname?.toUpperCase()} ${givenName}`,
    },
    {
      label: SUPERVISOR_TEXT.TITLE,
      value: title,
    },
    {
      label: SUPERVISOR_TEXT.JOB_TITLE,
      value: jobTitle,
    },
    {
      label: SUPERVISOR_TEXT.DEPARTMENT,
      value: department,
    },
    ...(polyuStaff
      ? []
      : [
          {
            label: SUPERVISOR_TEXT.INSTITUTION,
            value: institution,
          },
        ]),
    {
      label: SUPERVISOR_TEXT.EMAIL,
      value: email,
    },
  ];

  return (
    <Container>
      <div className="grid grid-cols-2 p-4 text-sm w-full">
        {renderData.map((item, index) => {
          return (
            <div key={index} className="py-2 border-b border-solid">
              <span className="text-[#224295]">{item.label}</span>:&nbsp;&nbsp;
              {item.value}
            </div>
          );
        })}
      </div>
      <div className="p-4 ">
        <Checkbox
          label={SUPERVISOR_TEXT.PREVIOUS_SUCCESSFUL_SUPERVISION}
          value={previousSuccessfulSupervision}
          size="small"
          disabled
        />
        {polyuStaff && (
          <>
            <Checkbox
              label={SUPERVISOR_TEXT.DRC_MEMBER}
              value={isDrcChair}
              size="small"
              disabled
            />
            <Checkbox
              label={SUPERVISOR_TEXT.DORPGS_MEMBER}
              value={isDoRPgS}
              size="small"
              disabled
            />
          </>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  h1 {
    text-align: left !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    margin: 1rem !important;
  }
  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-item {
    padding-left: 0 !important;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 2rem !important;
  }
`;
